'use es6';

import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DragDropContext(ComponentToDecorate, backend = HTML5Backend) {
  const displayName = ComponentToDecorate.displayName || ComponentToDecorate.name || 'Component';
  const wrapper = props => /*#__PURE__*/_jsx(DndProvider, {
    backend: backend,
    children: /*#__PURE__*/_jsx(ComponentToDecorate, Object.assign({}, props))
  });
  wrapper.displayName = `DragDropContextDecorator(${displayName})`;
  wrapper.wrappedComponent = ComponentToDecorate;
  return wrapper;
}